/* eslint-disable max-lines-per-function */
import { ReactElement, useMemo } from 'react';

import { FieldControllerProps } from '@dreryk/react-common';

import { DiagnosesInteractiveTable } from '../../../shared/table/DiagnosesInteractiveTable';

import { DiseaseWithBodySideAutosuggest } from './autosuggest/DiseaseWithBodySideAutosuggest';
import { createBodySideColumn } from './DiagnosesWithBodySideInteractiveTable.hooks';
import { DiagnosesWithBodySideTableBean } from './DiagnosesWithBodySideInteractiveTable.types';

type DiagnosesWithBodySideInteractiveTableProps = FieldControllerProps<
   `${string}.value`,
   DiagnosesWithBodySideTableBean[]
> & {
   readonly header: ReactElement;
};

export const DiagnosesWithBodySideInteractiveTable = (
   props: DiagnosesWithBodySideInteractiveTableProps
): JSX.Element => {
   const columns = useMemo(() => [createBodySideColumn()], []);
   return <DiagnosesInteractiveTable<DiagnosesWithBodySideTableBean> {...props} columns={columns} />;
};

DiagnosesWithBodySideInteractiveTable.Selector = DiseaseWithBodySideAutosuggest;
